var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "zcontainer" } },
    [
      _c("br"),
      _c("br"),
      _c("h1", [_vm._v("Citywide Projects")]),
      _c("h4", { staticStyle: { color: "#888" } }, [
        _vm._v(
          "A list of projects which are citywide in nature, or which can't be easily placed on the map."
        )
      ]),
      _c("br"),
      _vm.transitProjects.length > 0
        ? _c("h3", { staticClass: "project-heading" }, [
            _vm._v("TRANSIT PROJECTS")
          ])
        : _vm._e(),
      _vm._l(_vm.transitRows, function(rrow) {
        return _c(
          "transition-group",
          {
            key: "a" + rrow,
            staticClass: "visualizations ie-show",
            attrs: { name: "flip-list", tag: "ul" }
          },
          _vm._l([0, 1, 2], function(i) {
            return _vm.transitProjects.length > i + rrow * 3
              ? _c("li", { key: rrow * 3 + i, staticClass: "viz-thumbnail" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "/projects/" +
                          _vm.transitProjects[i + rrow * 3].project_number,
                        target: "_blank"
                      }
                    },
                    [
                      _c("div", { staticClass: "image-text-box" }, [
                        _c("img", {
                          staticClass: "thumbnail-image",
                          attrs: {
                            src: _vm.projectImages[
                              _vm.transitProjects[rrow * 3 + i].project_number
                            ]
                              ? "/static/project-thumbnails/" +
                                _vm.projectImages[
                                  _vm.transitProjects[rrow * 3 + i]
                                    .project_number
                                ]
                              : "/static/bus-seats.jpg"
                          }
                        }),
                        _c(
                          "h5",
                          { staticClass: "thumbnail-title bottom-left" },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.transitProjects[rrow * 3 + i].project_name
                                )
                              )
                            ])
                          ]
                        )
                      ]),
                      _c("p", { staticClass: "footnote" }, [
                        _vm._v(
                          _vm._s(_vm.transitProjects[rrow * 3 + i].sponsor)
                        )
                      ])
                    ]
                  )
                ])
              : _vm._e()
          }),
          0
        )
      }),
      _c(
        "transition-group",
        {
          staticClass: "visualizations ie-hide",
          attrs: { name: "flip-list", tag: "ul" }
        },
        _vm._l(_vm.transitProjects, function(prj, i) {
          return _c(
            "li",
            { key: prj.project_number, staticClass: "viz-thumbnail" },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: "/projects/" + prj.project_number,
                    target: "_blank"
                  }
                },
                [
                  _c("div", { staticClass: "image-text-box" }, [
                    _c("img", {
                      staticClass: "thumbnail-image",
                      attrs: {
                        src: _vm.projectImages[prj.project_number]
                          ? "/static/project-thumbnails/" +
                            _vm.projectImages[prj.project_number]
                          : "/static/bus-seats.jpg"
                      }
                    }),
                    _c("h5", { staticClass: "thumbnail-title bottom-left" }, [
                      _c("span", [_vm._v(_vm._s(prj.project_name))])
                    ])
                  ]),
                  _c("p", { staticClass: "footnote" }, [
                    _vm._v(_vm._s(prj.sponsor))
                  ])
                ]
              )
            ]
          )
        }),
        0
      ),
      _vm.transitProjects.length > 0 ? _c("br") : _vm._e(),
      _vm.streetProjects.length > 0
        ? _c(
            "h3",
            {
              staticClass: "project-heading",
              staticStyle: { "background-color": "#21ba45" }
            },
            [_vm._v("STREET PROJECTS")]
          )
        : _vm._e(),
      _vm._l(_vm.streetRows, function(rrow) {
        return _c(
          "transition-group",
          {
            key: "b" + rrow,
            staticClass: "visualizations ie-show",
            attrs: { name: "flip-list", tag: "ul" }
          },
          _vm._l([0, 1, 2], function(i) {
            return _vm.streetProjects.length > i + rrow * 3
              ? _c("li", { key: rrow * 3 + i, staticClass: "viz-thumbnail" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "/projects/" +
                          _vm.streetProjects[i + rrow * 3].project_number,
                        target: "_blank"
                      }
                    },
                    [
                      _c("div", { staticClass: "image-text-box" }, [
                        _c("img", {
                          staticClass: "thumbnail-image",
                          attrs: {
                            src: _vm.projectImages[
                              _vm.streetProjects[rrow * 3 + i].project_number
                            ]
                              ? "/static/project-thumbnails/" +
                                _vm.projectImages[
                                  _vm.streetProjects[rrow * 3 + i]
                                    .project_number
                                ]
                              : "/static/asphalt.jpg"
                          }
                        }),
                        _c(
                          "h5",
                          { staticClass: "thumbnail-title bottom-left" },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.streetProjects[rrow * 3 + i].project_name
                                )
                              )
                            ])
                          ]
                        )
                      ]),
                      _c("p", { staticClass: "footnote" }, [
                        _vm._v(_vm._s(_vm.streetProjects[rrow * 3 + i].sponsor))
                      ])
                    ]
                  )
                ])
              : _vm._e()
          }),
          0
        )
      }),
      _c(
        "transition-group",
        {
          staticClass: "visualizations ie-hide",
          attrs: { name: "flip-list", tag: "ul" }
        },
        _vm._l(_vm.streetProjects, function(prj, i) {
          return _c(
            "li",
            { key: prj.project_number, staticClass: "viz-thumbnail" },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: "/projects/" + prj.project_number,
                    target: "_blank"
                  }
                },
                [
                  _c("div", { staticClass: "image-text-box" }, [
                    _c("img", {
                      staticClass: "thumbnail-image",
                      attrs: {
                        src: _vm.projectImages[prj.project_number]
                          ? "/static/project-thumbnails/" +
                            _vm.projectImages[prj.project_number]
                          : "/static/asphalt.jpg"
                      }
                    }),
                    _c(
                      "h5",
                      { staticClass: "thumbnail-title bottom-left streets" },
                      [_c("span", [_vm._v(_vm._s(prj.project_name))])]
                    )
                  ]),
                  _c("p", { staticClass: "footnote" }, [
                    _vm._v(_vm._s(prj.sponsor))
                  ])
                ]
              )
            ]
          )
        }),
        0
      ),
      _vm.streetProjects.length > 0 ? _c("br") : _vm._e(),
      _vm.planningProjects.length > 0
        ? _c(
            "h3",
            {
              staticClass: "project-heading",
              staticStyle: { "background-color": "#bb9b3a" }
            },
            [_vm._v("PLANS AND STUDIES")]
          )
        : _vm._e(),
      _vm._l(_vm.planningRows, function(rrow) {
        return _c(
          "transition-group",
          {
            key: "c" + rrow,
            staticClass: "visualizations ie-show",
            attrs: { name: "flip-list", tag: "ul" }
          },
          _vm._l([0, 1, 2], function(i) {
            return _vm.planningProjects.length > i + rrow * 3
              ? _c("li", { key: rrow * 3 + i, staticClass: "viz-thumbnail" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "/projects/" +
                          _vm.planningProjects[i + rrow * 3].project_number,
                        target: "_blank"
                      }
                    },
                    [
                      _c("div", { staticClass: "image-text-box" }, [
                        _c("img", {
                          staticClass: "thumbnail-image",
                          attrs: {
                            src: _vm.projectImages[
                              _vm.planningProjects[rrow * 3 + i].project_number
                            ]
                              ? "/static/project-thumbnails/" +
                                _vm.projectImages[
                                  _vm.planningProjects[rrow * 3 + i]
                                    .project_number
                                ]
                              : "/static/blur.jpg"
                          }
                        }),
                        _c(
                          "h5",
                          { staticClass: "thumbnail-title bottom-left" },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.planningProjects[rrow * 3 + i]
                                    .project_name
                                )
                              )
                            ])
                          ]
                        )
                      ]),
                      _c("p", { staticClass: "footnote" }, [
                        _vm._v(
                          _vm._s(_vm.planningProjects[rrow * 3 + i].sponsor)
                        )
                      ])
                    ]
                  )
                ])
              : _vm._e()
          }),
          0
        )
      }),
      _c(
        "transition-group",
        {
          staticClass: "visualizations ie-hide",
          attrs: { name: "flip-list", tag: "ul" }
        },
        _vm._l(_vm.planningProjects, function(prj, i) {
          return _c(
            "li",
            { key: prj.project_number, staticClass: "viz-thumbnail" },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: "/projects/" + prj.project_number,
                    target: "_blank"
                  }
                },
                [
                  _c("div", { staticClass: "image-text-box" }, [
                    _c("img", {
                      staticClass: "thumbnail-image",
                      attrs: {
                        src: _vm.projectImages[prj.project_number]
                          ? "/static/project-thumbnails/" +
                            _vm.projectImages[prj.project_number]
                          : "/static/blur.jpg"
                      }
                    }),
                    _c(
                      "h5",
                      { staticClass: "thumbnail-title bottom-left plans" },
                      [_c("span", [_vm._v(_vm._s(prj.project_name))])]
                    )
                  ]),
                  _c("p", { staticClass: "footnote" }, [
                    _vm._v(_vm._s(prj.sponsor))
                  ])
                ]
              )
            ]
          )
        }),
        0
      ),
      _vm.planningProjects.length > 0 ? _c("br") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-508a1588", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-508a1588","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CitywideProjects.vue
// module id = null
// module chunks = 